import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { sub2_act1_Neto01, sub2_act1_Neto02, sub2_act1_Rolo01, sub2_act1_Rolo02, sub2_act1_Ticket } from '../../../assets/tema7';
import { voicesTypeControl } from '../../../types/audioType';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	win: 13
};

const pointTicket = [
	{ title: "Efectivo en caja", color: "#22C55E" },
	{ title: "Monto de los retiros de efectivo", color: "#F59E0B" },
	{ title: "Fondo fijo", color: "#589DBA" },
	{ title: "Monto de pagos electrónicos ", color: "#6758BA" },
]

export const Theme7SubtopicTwoActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema7.activities.subtema2], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 7 sub 1 act 1");
			ObserverEmitter.emit(EVENTS.tema7.topic2.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1a01)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema7.topic2.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 1: Corte X.' />
					<DialogBarNew
						dialog={`¡Observa, un cliente se acerca! enseguida, exploraremos el tema de control de efectivo.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2. Control de efectivo"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1n02)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.tema7.topic1.actScene, "move_client_1");
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<ViewPerson img={sub2_act1_Neto01} />
					<DialogBarNew
						name='Neto'
						dialog={`Buenas tardes. ¿En qué puedo ayudarle?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1r03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<ViewPerson img={sub2_act1_Rolo01} />
					<DialogBarNew
						name='Rolo'
						dialog={`Hace rato vine a comprar un capuchino mediano y unas galletas y me dieron mal el cambio. Pague con un billete de 100 y solo me dieron $16 pesos de feria.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1n04)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<ViewPerson img={sub2_act1_Neto02} />
					<DialogBarNew
						name='Neto'
						dialog={`¿Tiene el ticket de su compra?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1r05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<ViewPerson img={sub2_act1_Rolo02} />
					<DialogBarNew
						name='Rolo'
						dialog={`Sí, aquí está. Cuando me dieron el cambio no me percaté porque estaba hablando por teléfono, pero ahorita me di cuenta, por eso vine.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1a06)
							ObserverEmitter.emit(EVENTS.tema7.topic1.actScene, "move_desktop_1");
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`En estos casos se pide ayuda al Encargado de Tienda, o a el Líder, para realizar un Corte X y comparar que cuadre.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1a07)
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Los únicos autorizados para hacer un Corte X son los Encargados de Tienda o Líder. Este corte se realiza para cuadrar la información de lo que dice en el Sistema con lo que está en la caja. Los pasos son:`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1a08)
							ObserverEmitter.emit(EVENTS.tema7.topic1.actScene, "move_monitor_1");
							setUiToShow(steps.dialogEight);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`1.- Selecciona la opción Corte X en el sistema.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1a09)
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<div className='h-full w-full fixed z-40 bg-[#00000074] flex justify-center items-center'>
						<div className="w-[350px] h-[300px] md:w-[500px] md:h-[450px] gradiantBlueClient rounded-2xl md:rounded-[32px] md:p-4 border-[1px] border-white p-2">
							<div className='w-full h-[32px] md:h-[53px] px-4'>
								<div className="bg-red_primary w-full h-full rounded-lg flex justify-center items-center">
									<p className="text-white text-[12px] md:text-[16px]">Ticket Corte X</p>
								</div>
							</div>
							<div className="h-[calc(100%-32px)] md:h-[calc(100%-53px)] py-3 overflow-hidden flex md:px-4">
								<div className="w-[50%] h-full">
									<img className="h-full w-full" src={sub2_act1_Ticket} alt="ticket" />
								</div>
								<div className="w-[50%] h-full flex flex-col justify-center gap-2 md:gap-4">
									{pointTicket.map((iteam, index) => (
										<div key={`${index}-points-color`} className={`w-full h-[35px] md:h-[40px] rounded-[8px] flex justify-center items-center text-center p-2`} style={{ backgroundColor: iteam.color }}>
											<span className='text-white font-semibold text-[10px] md:text-[14px]'>{iteam.title}</span>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
					<DialogBarNew
						dialog={`2.- Se genera un ticket con la cantidad que hay en efectivo en caja los retiros, cantidad inicial y pagos electrónicos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1a10)
							ObserverEmitter.emit(EVENTS.tema7.topic1.actScene, "move_desktop_2");
							setUiToShow(steps.dialogTen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Si al Cliente se le entregó correctamente el cambio, debe coincidir lo que arroja el sistema en el ticket y el efectivo que está en caja.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema2.actividad1.sub2a1a11)
							setUiToShow(steps.dialogEleven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<DialogBarNew
						dialog={`Si hay más dinero en caja es porque no se entregó el cambio correcto. Ese sobrante debe ser el cambio que reclama el cliente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Ahora conoces la opción de Corte X en el sistema."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema7.activities.subtema2
								})
							);
							navigator("/home7/tema7/subtema2/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}


const ViewPerson = ({ img = "" }) => {
	return (
		<>
			<div className='fixed h-full w-full bg-[#00000074] flex justify-center items-center'>
				<div className='w-[250px] h-[250px] md:w-[500px] md:h-[500px]'>
					<img className='h-full w-full object-contain' src={img} alt="person" />
				</div>
			</div>
		</>
	)
}